import { VariantProps } from 'class-variance-authority'
import * as React from 'react'
import TextareaAutosize from 'react-textarea-autosize'

import { cn } from '../utils'
import { inputVariants } from './input'

export type MultilineProps = Omit<
  React.ComponentPropsWithoutRef<typeof TextareaAutosize>,
  'size'
> &
  VariantProps<typeof inputVariants>

const Multiline = React.forwardRef<HTMLTextAreaElement, MultilineProps>(
  ({ className, minRows = 3, size, variant, ...props }, ref) => {
    return (
      <TextareaAutosize
        className={cn(
          inputVariants({ size, variant }),
          'min-h-12 resize-none pt-3',
          { 'bg-input-background border-input-background': !!props.value },
          className,
        )}
        minRows={minRows}
        ref={ref}
        {...props}
      />
    )
  },
)
Multiline.displayName = 'Multiline'

export { Multiline }
